/**
 * InvoiceStatusBadge Component - T151
 *
 * Sprint 006 (A2): renders via the shared StatusBadge — one pill anatomy
 * + one tone role-map app-wide. Deliberate change: draft is neutral
 * (white/10) instead of amber, cancelled is terminal-muted.
 */
import { StatusBadge, type StatusTone } from '../ui';
import { statusLabels, type InvoiceStatus } from '../../hooks/useInvoices';

export const INVOICE_STATUS_TONES: Record<InvoiceStatus, StatusTone> = {
  draft: 'neutral',
  sent: 'info',
  paid: 'success',
  overdue: 'danger',
  cancelled: 'muted',
  deferred: 'warning',
};

interface InvoiceStatusBadgeProps {
  status: InvoiceStatus;
  /** Size variant for different contexts */
  size?: 'sm' | 'md';
  className?: string;
}

export function InvoiceStatusBadge({ status, size = 'md', className = '' }: InvoiceStatusBadgeProps) {
  return (
    <StatusBadge tone={INVOICE_STATUS_TONES[status]} size={size} className={className}>
      {statusLabels[status]}
    </StatusBadge>
  );
}
